import React from 'react';
import PropTypes from 'prop-types';
import WheelAlignmentService from './wheel_alignment_service';
import Translation from '../../../../translation/translation';
import getTranslatedText from '../../../../../helper/get_translated_text';

function WheelAlignment(props) {
    return (
        <div className="fsf-wheel-alignment">
            <p className="fsf-wheel-alignment__headline">Wheel Alignment</p>
            <p className="fsf-wheel-alignment__sub-headline">
                <Translation translationKey="fitting-station-finder-app-wheel-alignment-sub-headline"/>
                {' '}
                <Translation
                    tagName="span"
                    className="fsf-wheel-alignment__note-more-link"
                    translationKey="fitting-station-finder-app-wheel-alignment-note-read-more"
                    onClick={props.onShowMoreWheelAlignmentInfoClick}
                />
            </p>
            {!props.billable &&
                <Translation
                    tagName="p"
                    className="fsf-wheel-alignment__note"
                    translationKey="fitting-station-finder-app-wheel-alignment-note"
                />
            }
            {props.wheels_2 && props.wheelAlignment2IsShowable &&
                <WheelAlignmentService
                    wheelQuantity={2}
                    wheelAlignment={props.wheels_2}
                    billable={props.billable}
                    onChange={props.onWheels2Change}
                    checked={props.billable ? props.wheelAlignment2 : false}
                />
            }
            {props.wheels_4 && props.wheelAlignment4IsShowable &&
                <WheelAlignmentService
                    wheelQuantity={4}
                    wheelAlignment={props.wheels_4}
                    billable={props.billable}
                    onChange={props.onWheels4Change}
                    checked={props.billable ? props.wheelAlignment4 : false}
                />
            }
        </div>
    );
}

function Services(props) {
    const billable = props.showSelectStationButton ? props.wheelAlignment.billable : false;
    const hasWheelAlignment = props.wheelAlignment.wheels_2 || props.wheelAlignment.wheels_4;

    if (!props.displayAdditionalServices || !hasWheelAlignment) {
        return null;
    }

    return (
        <div className="fsf-station__detail">
           <h3 className="fsf-station__detail-headline">
               <Translation translationKey="fitting-station-finder-app-additional-service" />
           </h3>
           <div className="fsf-station__detail-contents">
                <div className="fsf-services">
                    {hasWheelAlignment &&
                        <WheelAlignment
                            billable={billable}
                            wheels_2={props.wheelAlignment.wheels_2}
                            wheelAlignment2={props.wheelAlignment2}
                            wheelAlignment2IsShowable={props.wheelAlignment.wheels_2_is_showable}
                            onWheels2Change={props.onWheels2Change}
                            wheels_4={props.wheelAlignment.wheels_4}
                            wheelAlignment4={props.wheelAlignment4}
                            wheelAlignment4IsShowable={props.wheelAlignment.wheels_4_is_showable}
                            onWheels4Change={props.onWheels4Change}
                            onShowMoreWheelAlignmentInfoClick={props.onShowMoreWheelAlignmentInfoClick}
                        />
                    }
                </div>
            </div>
        </div>
    );
}

Services.propTypes = {
    showSelectStationButton: PropTypes.bool.isRequired,
    wheelAlignment2: PropTypes.bool.isRequired,
    wheelAlignment4: PropTypes.bool.isRequired,
    onWheels2Change: PropTypes.func.isRequired,
    onWheels4Change: PropTypes.func.isRequired,
    onShowMoreWheelAlignmentInfoClick: PropTypes.func.isRequired,
    displayAdditionalServices: PropTypes.bool,
};

Services.defaultProps = {
    displayAdditionalServices: true,
};

export default Services;
